import { FileReader, FileWriter } from '@/platform'

class PropertyViewPort {
    public X: number = 0 // X坐标
    public Y: number = 0 // Y坐标
    public W: number = 0 // 宽度
    public H: number = 0 // 高度

    constructor(x: number = 0, y: number = 0, w: number = 0, h: number = 0) {
        this.X = x
        this.Y = y
        this.W = w
        this.H = h
    }

    readVersionedOui(reader: FileReader): void {
        this.X = reader.readInt()
        this.Y = reader.readInt()
        this.W = reader.readInt()
        this.H = reader.readInt()
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.X)
        writer.writeInt(this.Y)
        writer.writeInt(this.W)
        writer.writeInt(this.H)

        writer.writerLength()
    }
}

export default PropertyViewPort
